<template>
  <ModalConfirmation labelYes="OK"
                     labelNo="Cancel"
                     :name="name"
                     @before-open="beforeModalOpen"
                     @yes="deleteTenantUser">
    <div :style="containerStyle">
      <div>
        Are you sure you want to delete the following account?
      </div>
      <div :style="nameStyle">
        {{ userName }}
      </div>
      <div :style="emailStyle">
        ({{ email }})
      </div>
    </div>
  </ModalConfirmation>
</template>

<script>
  import ModalConfirmation from '@modals/modal-confirmation'
  import client from '@js/client'
  import resources from '@js/resources'
  import { FontStyle, Layout } from '@js/styles'
  import { mapState } from 'vuex'
  import { MODAL_WINDOW_NAMES } from '@js/constants'

  export default {
    name: 'ModalDeleteTenantUser',
    components: {
      ModalConfirmation,
    },
    data: function () {
      return {
        containerStyle: {
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
        },
        emailStyle: {
          fontSize: FontStyle.size.sm,
          fontWeight: FontStyle.weight.sm,
          margin: `${Layout.space.xs} 0 ${Layout.space.md} 0`,
        },
        name: MODAL_WINDOW_NAMES.DELETE_TENANT_USER_PRIMARY,
        nameStyle: {
          fontSize: FontStyle.size.md,
          fontWeight: FontStyle.weight.lg,
          margin: `${Layout.space.sm} 0 0 0`,
        },
        tenantUser: { user: {} },
      };
    },
    methods: {
      beforeModalOpen: function (e) {
        this.tenantUser = e.params.tenantUser;
      },
      deleteTenantUser: async function () {
        try {
          const url = await resources['tenantUser'](this.tenantDomain, this.tenantUser.id);
          const res = await client.delete(url);

          /*
          Vue router does not allow push to the same route.
          In order to force reloading components, push to dummy page first,
          and then push to correct page.
           */
          await this.$router.push({ name: 'dummy' });
          await this.$store.commit('notification/setWarning', `Deleted account of "${this.userName}".`);
          await this.$router.push({ name: 'admin-settings-users' });
        } catch (error) {
          this.$store.commit('notification/setWarning', 'Failed to delete user');
          console.error(error);
        }
      },
    },
    computed: {
      ...mapState({
        myTenantUserId: state => state.tenantUser.id,
        tenantDomain: state => state.tenant.domain,
      }),
      email: function () {
        return this.tenantUser.user.email;
      },
      userName: function () {
        return `${this.tenantUser.user.firstName} ${this.tenantUser.user.lastName}`;
      },
    }
  };
</script>
